/**
 * Storage drivers surface an exhausted origin quota under a couple of different
 * names depending on the browser. Chrome/Safari throw a DOMException named
 * QuotaExceededError, Firefox throws NS_ERROR_DOM_QUOTA_REACHED.
 */
const QUOTA_EXCEEDED_ERROR_NAMES = ['QuotaExceededError', 'NS_ERROR_DOM_QUOTA_REACHED']

export const isQuotaExceededError = (error: unknown): boolean => {
  if (!error || typeof error !== 'object') return false

  const { name } = error as { name?: unknown }

  return typeof name === 'string' && QUOTA_EXCEEDED_ERROR_NAMES.includes(name)
}
